// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import materialApi from '~/apis/material';
import {
  CREATE_MATERIAL,
  DELETE_MATERIAL,
  GET_MATERIAL_DETAIL,
  GET_MATERIAL_LIST,
  UPDATE_MATERIAL,
} from '~/utils/constants/actionType';
import { IQueryParamMaterial, IQueryUpdateMaterial } from '~/utils/interface/material';

export const getMaterialList = createAsyncThunk(
  GET_MATERIAL_LIST,
  async (params: IQueryParamMaterial, { rejectWithValue }) => {
    try {
      const resp = await materialApi.getMaterial(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createMaterial = createAsyncThunk(
  CREATE_MATERIAL,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const resp = await materialApi.createMaterial(formData);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteMaterial = createAsyncThunk(
  DELETE_MATERIAL,
  async (materialId: string, { rejectWithValue }) => {
    try {
      const resp = await materialApi.deleteMaterial(materialId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMaterialDetail = createAsyncThunk(
  GET_MATERIAL_DETAIL,
  async (materialId: string, { rejectWithValue }) => {
    try {
      const resp = await materialApi.getMaterialDetail(materialId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateMaterial = createAsyncThunk(
  UPDATE_MATERIAL,
  async (payload: IQueryUpdateMaterial, { rejectWithValue }) => {
    try {
      const resp = await materialApi.updateMaterial(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
